export default function showKennzahlenOverlay() {
  const overlay = document.getElementById('kennzahlen-overlay');
  const image   = document.getElementById('overlay-image');
  const showProzess  = document.getElementById('show-prozess');
  const showErgebnis = document.getElementById('show-ergebnis');
  const closeBtn = document.getElementById('close-overlay');
  const hotspotLayer = document.getElementById('hotspot-layer');
  const detailContainer = document.getElementById('detail-container');
  const detailImage = document.getElementById('detail-image');
  const detailClose = document.getElementById('detail-close');

  // --- deine Konfig wie zuvor (nur Pfade anpassen) ---
  const DASHBOARDS = {
    prozess: {
      base: 'images/prozess.png',
      items: [
        { label: 'Motivation',        rect: [ 2,28,31,62 ], detail: 'images/details/prozess_motivation.png' },
        { label: 'Zufriedenheit',     rect: [35,28,64,62 ], detail: 'images/details/prozess_zufriedenheit.png' },
        { label: 'Beteiligung',       rect: [68,28,97,62 ], detail: 'images/details/prozess_beteiligung.png' },
        { label: 'Nutzungsverhalten', rect: [ 2,66,31,100 ], detail: 'images/details/prozess_nutzung.png' },
        { label: 'Qualifikation',     rect: [35,66,64,100 ], detail: 'images/details/prozess_qualifikation.png' },
        { label: 'Vertrauen',         rect: [68,66,97,100 ], detail: 'images/details/prozess_vertrauen.png' },
      ]
    },
    ergebnis: {
      base: 'images/ergebnis.png',
      items: [
        { label: 'Produktionssteigerung',   rect: [ 2,43,20,80 ], detail: 'images/details/ergebnis_produktion.png' },
        { label: 'Mitarbeiterzufriedenheit',rect: [21,43,39,80 ], detail: 'images/details/ergebnis_mitarbeiter.png' },
        { label: 'Qualitätssteigerung',     rect: [40,43,58,80 ], detail: 'images/details/ergebnis_qualitaet.png' },
        { label: 'Kundenzufriedenheit',     rect: [60,43,79,80 ], detail: 'images/details/ergebnis_kunden.png' },
        { label: 'Kostensenkung',           rect: [81,43,98,80], detail: 'images/details/ergebnis_kosten.png' },
      ]
    }
  };

  let mode = 'prozess';

  overlay.classList.remove('hidden');

  function setActiveTab(newMode) {
    mode = newMode;
    showProzess.classList.toggle('active', mode==='prozess');
    showErgebnis.classList.toggle('active', mode==='ergebnis');

    // Übersicht setzen, Detail ggf. leeren
    image.src = DASHBOARDS[mode].base;
    hideDetail();               // oder: Detail behalten -> auskommentieren
    renderHotspots(DASHBOARDS[mode].items);
  }

  function hideDetail() {
    detailContainer.classList.add('hidden');
    detailImage.removeAttribute('src');
  }

  function showDetail(src) {
    detailImage.src = src;
    detailContainer.classList.remove('hidden');  // erscheint UNTER dem Hauptbild
  }

  function clearHotspots() {
    hotspotLayer.innerHTML = '';
  }

  function renderHotspots(items) {
    clearHotspots();
    for (const it of items) {
      const btn = document.createElement('button');
      btn.className = 'hotspot';
      btn.setAttribute('aria-label', it.label);

      const [l,t,r,b] = it.rect;
      btn.style.left = l + '%';
      btn.style.top = t + '%';
      btn.style.width = (r - l) + '%';
      btn.style.height = (b - t) + '%';

      btn.addEventListener('click', () => showDetail(it.detail));
      hotspotLayer.appendChild(btn);
    }
  }

  // Events
  showProzess.onclick  = () => setActiveTab('prozess');
  showErgebnis.onclick = () => setActiveTab('ergebnis');
  detailClose.onclick  = hideDetail;
  closeBtn.onclick     = () => overlay.classList.add('hidden');

  // Init
  setActiveTab('prozess');
}
